










































































































































import {
    State,
    Action,
    Getter,
    Mutation
} from "vuex-class";
import {
    Component,
    Vue,
    Prop
} from "vue-property-decorator";
import {
    pageDataType,
} from '../types';
import {
    HOST,
    API_URL
} from "../global";
import {
    pageData
} from "@/store/pageData";
import {
    FETCH_PAGE_BY_ID
} from "../store/actions.names";
import {
    ValidationObserver,
    ValidationProvider
} from "vee-validate";
import axios from 'axios';
import {
    TimelineMax,
    TweenLite,
    TweenMax,
    Power2,
    Power3,
    Power1
} from "gsap";
import ScrollMagic from "scrollmagic";
import gsap from 'scrollmagic';
const DEFAULT_JOBAPP_FORM = {
    name: "",
    email: "",
    mobile: "",
    phone: "",
    cover_letter: "",
    cv: null,
};
@Component({
    name: "JobDetailsPage",
    components: {
        ValidationObserver,
        ValidationProvider
    }
})
export default class JobDetailsPage extends Vue {
    @Prop() public pageData!: pageDataType;

    //  child page to parent page

    // public parentPage: pageDataType | null = null;
    // @Action(FETCH_PAGE_BY_ID)[FETCH_PAGE_BY_ID]: any;

    public jobappform: any = JSON.parse(JSON.stringify(DEFAULT_JOBAPP_FORM));
    submitted: boolean = false;
    submitSuccess: boolean = false;
    public HOST: string = HOST;

    resetForm() {
        this.jobappform = JSON.parse(JSON.stringify(DEFAULT_JOBAPP_FORM));
    }

    public submitForm() {
        (this as any).$refs.observer.validate().then((valid: any) => {
            const data = JSON.parse(JSON.stringify(this.jobappform));
            data.job = this.pageData.id;
            const formData = new FormData();
            if ((this as any).$refs.cv.files.length) {
                Object.keys(data).map((key: string) => {
                    if (["cv"].indexOf(key) == -1) {
                        formData.append(key, data[key]);
                    }
                });
                formData.append("cv", (this.$refs.cv as any).files[0]);
                axios
                    .post(`${API_URL}/job-apply/`, formData)
                    .then((resp: any) => {
                        this.submitted = true;
                        this.submitSuccess = true;
                    })
                    .catch((err: any) => {
                        this.submitted = true;
                    });

            }
        });
    }
    public heroimganim(): void {
        const {
            imgoverlay
        } = this.$refs
        TweenLite.delayedCall(1.5, overlay);

        function overlay() {
            TweenMax.to(imgoverlay, .3, {
                opacity: .4,
                ease: Power2.easeOut
            });
        }
        var heroimganim = new TimelineMax({});
        heroimganim
            .to(imgoverlay, .01, {
                opacity: 0,
            })

            .staggerFrom(".banner-wrap img", .8, {
                delay: .2,
                autoAlpha: 0,
                scale: 1.5,
                height: 100,
                y: 600,
                ease: Power2.easeOut,
                clearProps: 'all'
            }, 0.1)
            .to('.banner-text', .01, {
                overflow: 'hidden'
            })
            .staggerFrom('.banner-text h1', .6, {
                autoAlpha: 0,
                y: 80,
                ease: Power1.easeOut,
                clearProps: 'all'
            }, .1, '-=.05')
            .staggerFrom('.banner-text p', .6, {
                autoAlpha: 0,
                y: 80,
                ease: Power1.easeOut,
                clearProps: 'all'
            }, .2, '-=.3')
            .to('.banner-text', .01, {
                clearProps: 'all'
            });

    }
    public richtextAnim() {
        const controller1 = new ScrollMagic.Controller();
        const controller2 = new ScrollMagic.Controller();
        const controller3 = new ScrollMagic.Controller();

        var title = document.querySelectorAll('.career-richtext h3');
        var text = document.querySelectorAll('.career-richtext p');
        var list = document.querySelectorAll('.career-richtext ul');
        title.forEach((element) => {
            var title = element.children[0]
            var timeline = new TimelineMax();

            timeline
                .from(element, .8, {
                    yPercent: 30,
                    autoAlpha: 0,
                    width: '40%',
                    ease: Power2.easeOut,
                    clearProps: 'all'
                })

            // Make a ScrollMagic scene
            var scene = new ScrollMagic.Scene({
                    triggerElement: element,
                    reverse: false,
                })
                .setTween(timeline).addTo(controller1);
        });
        text.forEach((elem) => {
            var text = elem.children[0]
            var tl = new TimelineMax();

            tl
                .from(elem, .8, {
                    yPercent: 30,
                    autoAlpha: 0,
                    ease: Power2.easeOut,
                    clearProps: 'all'
                })

            // Make a ScrollMagic scene
            var scene1 = new ScrollMagic.Scene({
                    triggerElement: elem,
                    reverse: false,
                    // offset: 500
                })
                .setTween(tl).addTo(controller2);
        });
        list.forEach((el) => {
            var list = el.children[0]
            var tlm = new TimelineMax();

            tlm
                .from(el, .8, {
                    yPercent: 40,
                    autoAlpha: 0,
                    // delay: .3,
                    ease: Power2.easeOut,
                    clearProps: 'all'
                })

            // Make a ScrollMagic scene
            var scene2 = new ScrollMagic.Scene({
                    triggerElement: el,
                    reverse: false,
                    // offset: 500
                })
                .setTween(tlm).addTo(controller3);
        });
        // const tl2 = new TimelineMax()
        //     .staggerFrom('.career-richtext h3', .6, {
        //         yPercent: 40,
        //         autoAlpha: 0,
        //         ease: Power2.easeOut,
        //         clearProps: 'all'
        //     }, .01)
        //     .staggerFrom('.career-richtext p', .3, {
        //         yPercent: 40,
        //         autoAlpha: 0,
        //         ease: Power2.easeOut,
        //         clearProps: 'all'
        //     }, .2)
        //      .staggerFrom('.career-richtext ul', .3, {
        //         yPercent: 40,
        //         autoAlpha: 0,
        //         ease: Power2.easeOut,
        //         clearProps: 'all'
        //     }, .2)

        // const controller1 = new ScrollMagic.Controller();

        // const scene1 = new ScrollMagic.Scene({
        //         triggerElement: ".career-richtext",
        //         reverse: false,
        //     })
        //     .setTween(tl2)
        //     .addTo(controller1);

    }
    public mounted() {
        this.heroimganim();
        this.richtextAnim();
    }

}
